<template>
    <div class="cell-datetime" :class="{'cell-datetime-sm': size === 'small'}">
        <span class="date">{{date}}</span><span v-if="show_time" class="time" :class="{'time-sm': time_size === 'small', 'time-lg': time_size === 'large'}">{{time}}</span>
    </div>
</template>

<script>
export default {
    name: "CellDateTime",
    props: {
        datetime: String,
        show_time: {
            type: Boolean,
            default: true
        },
        date_format: {
            type: String,
            default: 'YYYY-MM-DD',
        },
        time_format: {
            type: String,
            default: 'HH:mm:ss',
        },
        size: {
            type: String,
            default: 'small',
        },
        time_size: {
            type: String,
            default: 'small',
        }
    },
    computed: {
        date() {
            return moment(this.datetime).format(this.date_format);
        },
        time() {
            return moment(this.datetime).format(this.time_format);
        }
    }
}
</script>

<style lang="scss" scoped>
    .cell-datetime {
        white-space: nowrap;
        .date {

        }
        .time {
            //font-size: 90%;
            color: #797777;
            margin-left: 3px;
        }
        .time-sm {
            font-size: 90%;
        }
        .time-lg {
            font-size: 115%;
            font-weight: bold;
        }
    }
    .cell-datetime-sm {
        font-size: 80%;
        //.date {
        //    font-size: 80%;
        //}
    }
</style>
